var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "mt-3 md_mt-5 flex container md_px-1 mx-auto flex-wrap md_mb-6"
    },
    [
      _c(
        "div",
        { staticClass: "w-1-3 hidden md_block" },
        [
          _c("responsive-image", {
            attrs: {
              sizes: "(min-width: 768px) 33.33%, 100vw",
              "image-object": _vm.leftImg,
              "alt-text": "Cool looking bro guy with tattoos"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "w-full md_w-1-3 bg-brand flex items-center justify-center text-center flex-col py-4 md_py-0"
        },
        [
          _c("div", { staticClass: "text-5xl md_text-2xl text-white" }, [
            _vm._v("Welcome to our")
          ]),
          _c("div", { staticClass: "text-5xl text-white font-bold" }, [
            _vm._v("InstaViralWorld")
          ]),
          _c("buyer-button", {
            staticClass: "mt-2_5",
            attrs: { long: "long", large: "large", text: "FOLLOW" },
            on: { click: _vm.buttonClickFollow }
          }),
          _c("div", { staticClass: "text-2xl md_text-lg text-white mt-3" }, [
            _vm._v("See all that's new on")
          ]),
          _c("div", { staticClass: "text-2xl md_text-lg text-white" }, [
            _vm._v("Instagram "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer font-bold hover_underline",
                on: {
                  click: _vm.buttonClickFollow,
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.buttonClickFollow($event)
                  }
                }
              },
              [_vm._v("@viralstyleofficial")]
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "w-full md_w-1-3" },
        [
          _c("responsive-image", {
            attrs: {
              sizes: "(min-width: 768px) 33.33%, 100vw",
              "image-object": _vm.rightImg,
              "alt-text": "Some other really cool looking people."
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }